export default {
  title: 'Update dropoff time',
  labels: {
    dropoff_time: 'Dropoff time',
    confirmed: 'Confirmed time:',
    new_time: 'New time:',
  },
  buttons: {
    save: 'Save',
  },
  toasts: {
    success: 'Dropoff time has been successfully updated',
    failed_to_save: 'Failed to save changes',
  },
  alerts: {
    dropoff_time_info: 'Both current time and new time are in {{restaurantName}} timezone {{timezone}}',
  },
};
